module.exports = __webpack_public_path__ + "files/c9564dbb91f79bc157bb27f7a4f95846.png";


//////////////////
// WEBPACK FOOTER
// ./images/icon50x50.png
// module id = 673
// module chunks = 60